export default "__VITE_ASSET__DuCH_TVm__"